<div class="w-full grid place-items-center py-8 min-h-[calc(100dvh-10rem)] sm:min-h-[calc(100dvh-10rem)] lg:min-h-[calc(100dvh-10rem)]">
  <div class="max-w-md w-full text-center">
    <div class="text-error mb-6 flex justify-center">
      <fa-icon [icon]="faLock" size="5x"></fa-icon>
    </div>

    <h1 class="text-3xl font-bold text-base-content">Access Denied</h1>

    <p class="mt-3 text-base-content/70">
      You don't have permission to view this page.
    </p>

    <div class="mt-8 flex justify-center">
      <a routerLink="/" class="btn btn-outline btn-error">
        Go back to Home
      </a>
    </div>
  </div>
</div>
